var _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_588_17137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_588_17137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 10V22C33 22.55 32.8043 23.021 32.413 23.413C32.021 23.8043 31.55 24 31 24H15C14.45 24 13.9793 23.8043 13.588 23.413C13.196 23.021 13 22.55 13 22V10C13 9.45 13.196 8.97933 13.588 8.588C13.9793 8.196 14.45 8 15 8H31C31.55 8 32.021 8.196 32.413 8.588C32.8043 8.97933 33 9.45 33 10ZM15 12H31V10H15V12ZM15 16V22H31V16H15Z",
    fill: "#44413B"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#44413B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.b2547e0a39a2e3f0cc1dfd0390f97e58.svg";
export { ForwardRef as ReactComponent };